
import { defineComponent } from 'vue'
import YieldRow from '../../form/bond/YieldRow.vue'
import { mapActions, mapState } from 'vuex'
import { ActionTypes } from '../../../store'

interface RowPayload {
  row: number;
  name: string;
  value: string;
}

export default defineComponent({
  name: 'YieldForm',
  components: {
    YieldRow
  },
  data () {
    return {
      numRows: 3,
      formset: [] as Record<string, string | boolean>[],
      results: {
        yields: [],
        total: 0
      },
      apiErrors: undefined
    }
  },
  computed: {
    ...mapState(['products'])
  },
  methods: {
    ...mapActions({
      fetchProducts: ActionTypes.FETCH_PRODUCTS_D,
      submitYields: ActionTypes.SUBMIT_YIELD_CALC
    }),
    rowUpdate (rowPayload: RowPayload) {
      const newFormset = [...this.formset]
      newFormset[rowPayload.row][rowPayload.name] = rowPayload.value
      this.formset = newFormset
      console.log(this.formset)
    },
    calculateYield () {
      // Filter out empty rows
      const validRows = this.formset.filter((row) => row.product !== '0')

      if (validRows.length > 0) {
        const payload = validRows.map(row => {
          return {
            product: parseInt(String(row.product)),
            ratio: parseFloat(String(row.ratio)) || 0,
            price: parseFloat(String(row.price)) || 0
          }
        })

        console.log('Sending payload:', payload)

        this.submitYields(payload).then((result) => {
          this.results = result
        }).catch((error) => this.apiErrors = error.response.data)
      }
    },
    initRows () {
      this.formset = [...Array(this.numRows).keys()].map(() => { return this.emptyRow() })
      this.results = {
        yields: [],
        total: 0
      }
    },
    emptyRow (): Record<string, string | boolean> {
      return {
        product: '0',
        price: '0',
        ratio: '0'
      }
    },
    async copyCurrentTotal() {
      const totalValue = this.results.total ? this.results.total.toFixed(3) : '0'
      try {
        await navigator.clipboard.writeText(totalValue)
      } catch (err) {
        const textArea = document.createElement('textarea')
        textArea.value = totalValue
        document.body.appendChild(textArea)
        textArea.select()
        document.execCommand('copy')
        document.body.removeChild(textArea)
      }
    }
  },
  created () {
    this.fetchProducts()
    this.initRows()
  }

})
